import React from "react";

const Ourfleets = () => {
 const galleryData = [
  {
    id: 1,
    imgSrc: "/images/fleets/amaze.png",
    title: "Honda Amaze",
    description:
      "Honda Amaze is a fuel-efficient compact sedan ideal for city rides, office commutes, and airport transfers.",
    link: "/honda-amaze",
  },
  {
    id: 2,
    imgSrc: "/images/fleets/aura.png",
    title: "Hyundai Aura",
    description:
      "Hyundai Aura is a stylish compact sedan offering great mileage and a smooth travel experience.",
    link: "/hyundai-aura",
  },
  {
    id: 3,
    imgSrc: "/images/fleets/etios.png",
    title: "Toyota Etios",
    description:
      "Toyota Etios is a spacious and reliable sedan perfect for business travel and outstation trips.",
    link: "/etios",
  },
  {
    id: 4,
    imgSrc: "/images/fleets/honda-city.png",
    title: "Honda City",
    description:
      "Honda City offers premium comfort, refined performance, and a luxury sedan experience.",
    link: "/honda-city",
  },
  {
    id: 5,
    imgSrc: "/images/fleets/ertiga.png",
    title: "Maruti Ertiga",
    description:
      "Ertiga is a comfortable 7-seater MPV designed for family travel and long-distance journeys.",
    link: "/ertiga",
  },
  {
    id: 6,
    imgSrc: "/images/fleets/innova.png",
    title: "Toyota Innova",
    description:
      "Toyota Innova is known for its reliability, comfort, and smooth long-distance performance.",
    link: "/innova",
  },
  {
    id: 7,
    imgSrc: "/images/fleets/innova-crysta.png",
    title: "Innova Crysta",
    description:
      "Innova Crysta offers a premium MPV feel with captain seats and a powerful engine.",
    link: "/innova-crysta",
  },
  {
    id: 8,
    imgSrc: "/images/fleets/kia.png",
    title: "Kia Carens",
    description:
      "Kia Carens is a modern 6/7-seater MPV with advanced features and luxury comfort.",
    link: "/kia-carens",
  },
  {
    id: 9,
    imgSrc: "/images/fleets/tempo-traveller.png",
    title: "Tempo Traveller",
    description:
      "Tempo Traveller is perfect for group tours, family functions, and corporate travel.",
    link: "/tempo-traveller",
  },
  {
    id: 10,
    imgSrc: "/images/fleets/mini-bus.png",
    title: "Mini Bus",
    description:
      "Mini Bus is ideal for team outings, office staff transport, and long tours.",
    link: "/mini-bus",
  },
  {
    id: 11,
    imgSrc: "/images/fleets/bus.png",
    title: "AC Bus",
    description:
      "Our AC Bus is suitable for large group tours, school trips, and pilgrimage travel.",
    link: "/ac-bus",
  },
  {
    id: 12,
    imgSrc: "/images/fleets/audi.png",
    title: "Audi A5",
    description:
      "Audi A5 is a premium luxury sedan offering a high-end chauffeur-driven experience.",
    link: "/audi-a5",
  },
];


  return (
    <>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>Our Fleets</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fleet Grid Section */}
      <section
        className="fleet-section section-padding"
        style={{ padding: "70px 0", background: "#f8fbff" }}
      >
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold" style={{ color: "#542E90" }}>
              Our Premium Fleet Collection
            </h2>
            <p style={{ color: "#555", fontSize: "17px" }}>
              Explore our modern, well-maintained vehicles offering comfort,
              safety, and reliability for every journey.
            </p>
          </div>

          <div className="row g-4">
            {galleryData.map((item) => (
              <div key={item.id} className="col-xl-4 col-md-6 col-12">
                <div
                  className="fleet-card shadow-lg border-0 rounded-4"
                  style={{
                    background: "#fff",
                    transition:
                      "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="fleet-image position-relative"
                    style={{
                      overflow: "hidden",
                      borderTopLeftRadius: "1rem",
                      borderTopRightRadius: "1rem",
                    }}
                  >
                    <img
                      src={item.imgSrc}
                      alt={item.title}
                      className="img-fluid w-100"
                      style={{
                        height: "220px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                    />
                  </div>

                  <div className="fleet-content p-4 text-center">
                    <h4 style={{ color: "#542E90", fontWeight: "600" }}>
                      {item.title}
                    </h4>
                    <p
                      style={{
                        color: "#444",
                        fontSize: "15px",
                        lineHeight: "1.6",
                        minHeight: "90px",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Ourfleets;
